import { render, staticRenderFns } from "./RatingEdit.vue?vue&type=template&id=50b5f8d8&scoped=true"
import script from "./RatingEdit.vue?vue&type=script&lang=js"
export * from "./RatingEdit.vue?vue&type=script&lang=js"
import style0 from "./RatingEdit.vue?vue&type=style&index=0&id=50b5f8d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b5f8d8",
  null
  
)

export default component.exports